import { Link } from 'react-router-dom';
import { EnvelopeSimple, TwitterLogo, InstagramLogo } from '@phosphor-icons/react';

export default function Footer() {
  return (
    <footer className="bg-card border-t-2 border-foreground mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img src="/grade9ready-logo.png" alt="Grade9Ready" className="h-10 w-auto" />
              <span className="font-heading font-bold text-xl">Grade9Ready</span>
            </div>
            <p className="text-muted-foreground text-sm">
              Helping UK students achieve Grade 9 success from Year 7 to GCSE.
            </p>
          </div>

          {/* Subjects */}
          <div>
            <h4 className="font-heading font-bold mb-4">Subjects</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/maths" className="hover:text-primary transition-colors">Maths</Link></li>
              <li><Link to="/english" className="hover:text-primary transition-colors">English Language</Link></li>
              <li><Link to="/subjects" className="hover:text-primary transition-colors">Combined Science</Link></li>
              <li><Link to="/subjects" className="hover:text-primary transition-colors">History</Link></li>
              <li><Link to="/subjects" className="hover:text-primary transition-colors">Geography</Link></li>
            </ul>
          </div>

          {/* Revision Guides — public, indexable. Provides Googlebot a crawl
              path into the SEO subject hubs from every page on the site. */}
          <div>
            <h4 className="font-heading font-bold mb-4">Revision guides</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/gcse-maths-revision" className="hover:text-primary transition-colors" data-testid="footer-link-maths-hub">GCSE Maths Revision</Link></li>
              <li><Link to="/gcse-english-revision" className="hover:text-primary transition-colors" data-testid="footer-link-english-hub">GCSE English Revision</Link></li>
              <li><Link to="/gcse-science-revision" className="hover:text-primary transition-colors" data-testid="footer-link-science-hub">GCSE Science Revision</Link></li>
              <li><Link to="/gcse-required-practicals" className="hover:text-primary transition-colors" data-testid="footer-link-required-practicals">Required Practicals</Link></li>
              <li><Link to="/for-parents" className="hover:text-primary transition-colors">For Parents</Link></li>
            </ul>
          </div>

          {/* Free tools — printable, no-signup linkable assets */}
          <div>
            <h4 className="font-heading font-bold mb-4">Free tools</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/free-revision-planner" className="hover:text-primary transition-colors" data-testid="footer-link-revision-planner">Revision Planner</Link></li>
              <li><Link to="/gcse-grade-boundaries-calculator" className="hover:text-primary transition-colors" data-testid="footer-link-grade-calc">Grade Boundaries Calculator</Link></li>
              <li><Link to="/gcse-maths-examiner-tips" className="hover:text-primary transition-colors" data-testid="footer-link-maths-tips">Maths Examiner Tips</Link></li>
              <li><Link to="/gcse-english-examiner-tips" className="hover:text-primary transition-colors" data-testid="footer-link-english-tips">English Examiner Tips</Link></li>
              <li><Link to="/gcse-science-examiner-tips" className="hover:text-primary transition-colors" data-testid="footer-link-science-tips">Science Examiner Tips</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-bold mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/pricing" className="hover:text-primary transition-colors">Pricing</Link></li>
              <li><Link to="/faq" className="hover:text-primary transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading font-bold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link></li>
              <li><Link to="/safeguarding" className="hover:text-primary transition-colors">Safeguarding</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t-2 border-foreground/20 mt-8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Grade9Ready. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="mailto:hello@grade9ready.com" className="p-2 rounded-lg border-2 border-foreground bg-card hover:bg-secondary transition-colors" aria-label="Email">
              <EnvelopeSimple size={20} weight="bold" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg border-2 border-foreground bg-card hover:bg-secondary transition-colors" aria-label="Twitter">
              <TwitterLogo size={20} weight="bold" />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg border-2 border-foreground bg-card hover:bg-secondary transition-colors" aria-label="Instagram">
              <InstagramLogo size={20} weight="bold" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
